// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hero[data-v-72cfa78a]{margin-top:47px}@media(min-width:900px){.hero[data-v-72cfa78a]{margin-top:0}}.job-search-container[data-v-72cfa78a]{z-index:2;position:relative}@media(max-width:900px){.job-search-container[data-v-72cfa78a]{padding:0!important;border-radius:0!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
